export const SHOW_WORKFLOW='showworkflow'
export const CLOSE_REPORT='closereport'

export const GET_NOTIFICATIONS_END='getnotifications.end'
export const GET_APPROVAL_DETAILS_END='getapprovaldetails.end'

export const HANDLE_INPUT_CHANGES='handleinputchange'
export const EXCECUTE_PROCCESS_ACTION_END='excecuteproccessaction.end'



